<template>
  <div id="code">
    <InlineLoading v-if="code === undefined" />
    <div v-else-if="code">
      <h1>{{ code }}</h1>
      <p class="hint">请将手机号和上方礼品码提供给店员</p>
    </div>
    <p v-else>无法查看礼品码</p>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      code: undefined,
    }
  },
  methods: {
    async getCoupon() {
      this.code = await this.$api.storeGift.CODE(this.id)
    },
  },
  created() {
    this.getCoupon()
  },
}
</script>

<style lang="scss" scoped>
#code {
  text-align: center;
  padding-bottom: 15px;
  .hint {
    opacity: 0.6;
    margin-top: 10px;
  }
}
</style>
